import _ from 'lodash';
import { ISession } from '@/types';

/** TODO: Use interface from API types */
export interface IEventLike {
  readonly event: string;
  readonly eventValue?: {
    readonly Message?: string;
  };
  readonly timestamp: string | number | Date;
}

/**
 * Text events include content written by a contact or an agent.
 * They also include transcripts based on phone calls.
 */
export const getTextEvents = <T extends IEventLike>(options: {
  events: T[];
  sortByTimestamp?: boolean;
}) => {
  const TEXT_EVENTS = ['Transcript', 'Notification', 'WhisperToAgent'];
  const { events, sortByTimestamp = true } = options;

  const result = events.filter(e => TEXT_EVENTS.includes(e.event));
  return sortByTimestamp
    ? _.sortBy(result, e => new Date(e.timestamp).getTime())
    : result;
};

export const getLastTranscript = <T extends IEventLike>(args: {
  events: T[];
}) => {
  const TRANSCRIPT_EVENT = 'Transcript';
  const { events = [] } = args;

  const transcripts = events.filter(e => {
    return e.event === TRANSCRIPT_EVENT && e.eventValue?.Message;
  });
  const orderByTimestamp = _.sortBy(transcripts, e => {
    return new Date(e.timestamp).getTime();
  });

  return orderByTimestamp[orderByTimestamp.length - 1];
};

/** Return messages as an array of strings with backwards compatibility */
export const getSessionTranscripts = (session: ISession) => {
  if (!_.isEmpty(session.transcript)) {
    return Object
      .values(session.transcript)
      .sort((a, b) => {
        return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
      })
      .map(t => t.content);
  }

  if (!_.isEmpty(session.transcripts)) {
    /* Match both escaped and unescaped \n */
    const LINE_REGEX = /\n|\\n/;
    return session.transcripts!.split(LINE_REGEX);
  }

  return [];
};
